"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var SelectField_1 = require("./SelectField");
var lib_1 = require("../lib");
var i18n_1 = require("@wordpress/i18n");
var hooks_1 = require("preact/hooks");
function ProjectDatesFields(_a) {
    var startDateString = _a.startDateString, durationDays = _a.durationDays, fixedDates = _a.fixedDates, setStartDate = _a.setStartDate, setDurationDays = _a.setDurationDays;
    var handleDateChange = function (event) {
        var value = event.target.value;
        if (value !== '') {
            /* Duration added to date value, as same start date can have different durations */
            var valueParts = value.split('|');
            setStartDate(valueParts[0]);
            setDurationDays(valueParts[1]);
        }
        else {
            setStartDate('');
            setDurationDays('');
        }
    };
    (0, hooks_1.useEffect)(function () {
        var dateField = document.getElementById('fixed_date');
        dateField.value = dateField.value;
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SelectField_1.default, { name: "fixed_date", label: (0, i18n_1.__)("Start date (fixed)", "projects-abroad"), options: fixedDates.map(function (o) { return ({
                    id: "".concat(o.startDate, "|").concat(o.durationDays),
                    name: "".concat(o.name, " - ").concat((0, lib_1.getDurationLabel)(o.durationDays)),
                }); }), defaultOptionLabel: (0, i18n_1.__)("Select a date", "projects-abroad"), required: true, onChange: handleDateChange, value: startDateString && durationDays ? "".concat(startDateString, "|").concat(durationDays) : '' }), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "start_date", value: startDateString }), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "duration_days", value: durationDays })] }));
}
exports.default = ProjectDatesFields;
